export default "__VITE_ASSET__6e53e8df__"